var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.parseBoolean(_vm.section.design['parallax-background-image']) && _vm.allowParallax
  )?_c('v-parallax',_vm._b({attrs:{"src":_vm.image.src,"lazy-src":_vm.image['lazy-src']}},'v-parallax',_vm.$attrs,false)):_c('v-img',_vm._b({attrs:{"src":_vm.image.src,"lazy-src":_vm.image['lazy-src']}},'v-img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }